import { qs, qsa, add, contains } from "@fluorescent/dom";
import { ImageReveal, FadeUpReveal, shouldAnimate } from "@/lib/animation";

const selectors = {
  details: ".product__details .animation-fade-up-reveal",
  images: ".product__media-container .product__media-item .image",
  featuredImage:
    ".product__media-container .product__media-item:not(.hidden) .image",
  remainingImages:
    ".product__media-container .product__media-item.hidden .image",
  detailsLeft: ".product__media-container .animation-fade-up-reveal",
};

const classes = {
  isListStyle: "product--gallery-style-list",
  isThumbnailStyle: "product--gallery-style-thumbnails",
  isMobileThumbnailStyle: "product--mobile-gallery-style-thumbnails",
  isGridStyle: "product--gallery-style-grid",
};

export default node => {
  const revealsRight = [];
  const revealsLeft = [];

  const details = qsa(selectors.details, node);
  const images = qsa(selectors.images, node);
  const featuredImage = qs(selectors.featuredImage, node);
  const remainingImages = qsa(selectors.remainingImages, node);
  const detailsLeft = qsa(selectors.detailsLeft, node);

  if (shouldAnimate(node)) {
    details.forEach(item => {
      revealsRight.push(new FadeUpReveal(item));
    });

    if (contains(node, classes.isListStyle)) {
      images.forEach(image => {
        revealsLeft.push(new ImageReveal(image));
      });
    } else if (contains(node, classes.isGridStyle)) {
      // Grid layout doesn't look great with any animations
      add(images, "animation-initialized");
    } else if (
      contains(node, classes.isThumbnailStyle) ||
      contains(node, classes.isMobileThumbnailStyle)
    ) {
      if (featuredImage) {
        revealsLeft.push(new ImageReveal(featuredImage));
      }

      if (remainingImages) {
        add(remainingImages, "animation-initialized");
      }
    }

    detailsLeft.forEach(item => {
      revealsLeft.push(new FadeUpReveal(item));
    });

    revealsRight.forEach((reveal, i) => {
      reveal.play(window.theme.animation.delayExtraShort * i);
    });
    revealsLeft.forEach((reveal, i) => {
      reveal.play(
        window.theme.animation.delayExtraShort * i +
          window.theme.animation.delayExtraShort
      );
    });

    setTimeout(() => {
      add(node, "animation--complete");
    }, (revealsRight.length + revealsLeft.length) * window.theme.animation.duration);
  }
};
